module.exports = __webpack_public_path__ + "img/donation-step-3.93a164de.png";